<script setup lang="ts">
defineProps<{
  block: BlockItem,
  noHorizontalPadding?: boolean,
}>()
</script>

<template>
  <section class="container-d my-3" :class="{ 'px-1': !noHorizontalPadding }">
    <h2 v-if="block.label" class="label">
      {{ block.label }}
    </h2>

    <core-maskable-media
      :use-mask="block.useMask"
      :image="block.image"
      :masked-media="block.maskedMedia"
      class="my-1 !w-3/4"
    />

    <template v-if="hasRichTextContent(block.richText)">
      <core-truncated-rich-text
        v-if="block.truncate"
        :content="block.richText"
      />
      <core-rich-text
        v-else
        :content="block.richText"
      />
    </template>

    <site-payload-link
      v-if="block.link"
      :data="block.link"
      class="inline-block mt-1 text-hover-accent text-d"
    />
  </section>
</template>
